import {
  createBrowserHistory,
  BrowserHistoryBuildOptions,
  History,
  LocationDescriptor,
} from 'history';

import { searchParamKeeplist, hashParamKeeplist } from 'src/config';
import { getLocationDescriptor } from 'src/utils/getLocationDescriptor';
import { keepParams } from 'src/utils/keepParams';

function customCreateBrowserHistory<S = unknown>(
  options?: BrowserHistoryBuildOptions | undefined,
): History<S> {
  const history = createBrowserHistory<S>(options);

  const push = (locationDescriptor: LocationDescriptor<S>, state?: S) => {
    const { location } = history;
    const { search: currentSearch, hash: currentHash } = location;

    const currentSearchParams = new URLSearchParams(currentSearch);
    const currentHashParams = new URLSearchParams(currentHash.slice(1));

    const {
      pathname: linkPathname,
      search: linkSearch,
      hash: linkHash,
      state: linkState,
    } = getLocationDescriptor<S>(location, locationDescriptor);

    const linkSearchParams = new URLSearchParams(linkSearch);
    const linkHashParams = new URLSearchParams(linkHash);

    // Keep those current search parameters that are in `searchParamKeeplist`
    // and are not provided by the next location descriptor
    keepParams(currentSearchParams, linkSearchParams, searchParamKeeplist);

    // And also those current hash parameters that are in `hashParamKeeplist`
    // and are not provided by the next location descriptor
    keepParams(currentHashParams, linkHashParams, hashParamKeeplist);

    history.push({
      pathname: linkPathname,
      search: linkSearchParams.toString(),
      hash: linkHashParams.toString(),
      state: linkState ?? state,
    });
  };

  return {
    ...history,
    push,
  };
}

export { customCreateBrowserHistory as createBrowserHistory };
